export default "__VITE_ASSET__CDebPGoW__"